import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header, Footer } from './components';
import { Home } from './pages/Home';
import { ProductDetail } from './pages/ProductDetail';
import { Privacy } from './pages/Privacy';
import { NotFound } from './pages/NotFound';
import { products, discordLink, emailLink, links } from './data';
import { CONTACT_EMAIL, COPYRIGHT_TEXT } from './utils/constants';
import { html as privacyHtml } from './data/privacy.md';
import './styles/globals.css';

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col bg-deepBlack">
        <Header siteName="FERAL-AUD.IO" />
        
        <main className="flex-grow">
          <Routes>
            <Route 
              path="/" 
              element={
                <Home 
                  products={products} 
                  communityLink={discordLink}
                />
              } 
            />
            <Route 
              path="/products/:id" 
              element={<ProductDetail />} 
            />
            <Route 
              path="/privacy"  
              element={
                <Privacy 
                  content={privacyHtml}
                  lastUpdated="May 2026"
                />
              } 
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer 
          contactEmail={emailLink?.label || CONTACT_EMAIL}
          links={links}
          copyright={COPYRIGHT_TEXT}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
